<script>
import Swal from 'sweetalert2';
import {RAW_MATERIAL_PATH} from '@/path.js';
import axios from 'axios';

    export default {
        props : ['selectedOrder','is_view'],
    data() {
        return {
            form: {},
            items : [],
            baseUrl : process.env.VUE_APP_API_BACKEND_URL,
            key : 1,
        };
    },
    computed :{
        RAW_MATERIAL_PATH(){
            return RAW_MATERIAL_PATH
        }
    },
    watch : {
        'form.invoice_amount'(v){
            if(!this.isEmpty(this.form.qty)){
                this.form.unit_price = (v / this.form.qty).toFixed(4);
            }
        },
    },
    methods : {
        async getItems(){
                try {
                    let res = await axios.get(this.baseUrl + RAW_MATERIAL_PATH.GET_ORDER_ITEMS,{
                        params : {
                            invoice_date : this.form.invoice_date,
                            invoice_number : this.form.invoice_number,
                            vendor : this.form.vendor,
                            status : this.form.status,
                            date_of_receiving : this.form.date_of_receiving
                        }
                    });
                    if(res.data.status){
                        this.items = res.data.data.map(r => {                        
                            r.qty_received = r.qty;  
                            r.unit_price_on_recieve =  (r.invoice_amount / r.qty_received).toFixed(2);                                                    
                            return r;
                        });
                    }
                } catch (error) {
                    console.log(error);
                }
        },                
        async saveOrder(){            
            try {
                this.form.items = this.items;
                let res = await axios.post(this.baseUrl + RAW_MATERIAL_PATH.MARK_AS_RECEIVED,this.form);
                if(res.data.status){
                    this.$emit('reload');
                    Swal.fire("Order Saved","","success");
                }else{
                    console.log(res);
                    this.$emit('reload');
                    Swal.fire("Order Failed to save","","error");
                }
            } catch (error) {
                console.log(error);
            }
        }
    },
    mounted(){
        console.log(this.selectedOrder);
        if(this.selectedOrder){            
            this.form.vendor = this.selectedOrder.vendor;
            this.form.invoice_number = this.selectedOrder.invoice_number;
            this.form.invoice_date = this.selectedOrder.invoice_date;
            this.form.date_of_receiving = this.selectedOrder.date_of_receiving;
            this.form.status = this.selectedOrder.status;
            this.key +=1;
            this.getItems();
        }
    }    
}
</script>

<template>
    <div>
        <!-- <b-row>
            <b-col sm="12">
                <label>Item</label>
                <SelectWithSearch v-if="!is_view" :search_api="RAW_MATERIAL_PATH.SEARCH_ITEMS" :selected_data="[selectedOrder ? selectedOrder.raw_material.id : form.item_id]" selected_by="id" track_by="id" display="name" @selectedOption="selectedMaterial"></SelectWithSearch>
                <p v-else>{{ selectedOrder.raw_material.name  }}</p>
            </b-col> 
        </b-row> -->
        <b-row :key="key">                       
            <!-- <b-col sm="6">
                <label>Batch Code</label>
                <b-input :readonly="is_view ? true : false" v-model="form.batch_code"></b-input>
            </b-col> -->
            <!-- <b-col sm="6">
                <label>Vendor</label>
                <b-input :readonly="is_view ? true : false" v-model="form.vendor"></b-input>
            </b-col>
            <b-col sm="6">
                <label>invoice_number</label>
                <b-input :readonly="is_view ? true : false" v-model="form.invoice_number"></b-input>
            </b-col>
            <b-col sm="6">
                <label>Invoice Date</label>
                <b-datepicker :readonly="is_view ? true : false" v-model="form.invoice_date"></b-datepicker>
            </b-col>
            <b-col sm="6">
                <label>Date of receiving</label>
                <b-datepicker :readonly="is_view ? true : false" v-model="form.date_of_receiving"></b-datepicker>
            </b-col> -->
            <!-- <b-col sm="6">
                <label>Best Before Date</label>
                <b-datepicker :readonly="is_view ? true : false" v-model="form.best_before_date"></b-datepicker>
            </b-col> -->
            <!-- <b-col sm="6">
                <label>Qty Expected</label>
                <b-input :readonly="is_view ? true : false" type="number" v-model="form.qty"></b-input>
            </b-col>
            <b-col sm="6">
                <label>Qty Received</label>
                <b-input :readonly="is_view ? true : false" type="number" v-model="form.qty_received"></b-input>
            </b-col> -->
            <!-- <b-col sm="6">
                <label>Total Amount (Rs)</label>
                <b-input :readonly="is_view ? true : false" type="number" v-model="form.invoice_amount"></b-input>
            </b-col> -->
            <!-- <b-col sm="6">
                <label>Pack Size</label>
                <b-input :readonly="is_view ? true : false" type="number" v-model="form.pack_size"></b-input>
            </b-col>
            <b-col sm="6">
                <label>Uom</label>
                <b-select :readonly="is_view ? true : false" :options="['Kgs','Box','Pcs','Tray','Ltr']" v-model="form.uom"></b-select>
            </b-col>
            <b-col sm="6">
                <label>Unit Price</label>
                <b-input :readonly="is_view ? true : false" type="number" v-model="form.unit_price"></b-input>
            </b-col>             -->
        </b-row>        
        <table class="table">
            <thead>
                <tr>                    
                    <th>Raw Material</th>
                    <th>Batch Code</th>
                    <th>Qty</th>                    
                    <th>Qty Received</th>    
                    <th>Total Price</th>     
                    <th>Unit Price</th>     
                    <th>Comments</th>                                                            
                </tr>
            </thead>
            <tbody>
                <tr v-for="(it,i) in items" :key="i">
                    <td>
                        <!-- <SelectWithSearch v-if="!is_view" :search_api="RAW_MATERIAL_PATH.SEARCH_ITEMS" :selected_data="[it.item_id]" selected_by="id" track_by="id" display="name" @selectedOption="selectedMaterial(i,$event)"></SelectWithSearch> -->
                        {{ it.raw_material.name }}
                    </td>
                    <td>
                        {{ it.batch_code }}
                    </td>
                    <td>
                        {{it.qty}}
                    </td>
                    <td>
                        <b-input type="number" v-model="it.qty_received"></b-input>
                    </td> 
                    <td>
                        <b-input type="number" v-model="it.invoice_amount"></b-input>
                    </td> 
                    <td>
                        <b-input type="number" v-model="it.unit_price_on_recieve"></b-input>
                    </td> 
                    <td>
                        <b-input type="text" v-model="it.comments"></b-input>
                    </td>                   
                </tr>
            </tbody>
        </table>
        <b-card-footer class="mt-4">
            <b-button variant="success" @click="saveOrder">Mark As Received</b-button>
        </b-card-footer>
    </div>
</template>

<style>
    
</style>